exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ustn .common-line[data-v-344763ff]{height:1px;width:70%;margin:1.73rem auto 1.38rem auto;background:linear-gradient(91deg, #efefef, #ccc, #efefef)}\n", ""]);

// exports
